<style scoped>
  .info-list-table {
    border: 1px black solid;
    width: 100%;
  }

  .num1 {
    font-size: 40px;
    /*color:#027DB4;*/
    font-weight: 600;
  }

  .num2 {
    color: #027DB4;
  }

  .title-blue {
    background: #4187ff;
    color: white;
    height: 50px;
    text-align: left;
    /*align-items: center;
    display: flex;*/
  }

  .title-blue > div {
    padding: 13px 20px 10px 20px;
  }

  .round-grey {
    background: #F0F0F0;
    border: 1px #F0F0F0 solid;
    border-radius: 25px;
    margin-bottom: 20px;
    height: 40px;
    padding: 7px;

  }

  .round-blue {
    background: #E9F0FC;
    color: #5189F6;
    padding: 10px;
    margin: 0 10px 0 10px;
    border-radius: 10px;
    text-align: left;
    font-weight: 500;
  }

  .row-grey245 {
    background: #F5F5F5;
    height: 10px;
  }

  .row-white {
    padding: 10px;
    border-bottom: 1px solid #EEEEEE;
    margin: 0 10px 0 10px;
    text-align: left;
  }

  .arrow {
    color: white;
    margin-top: 3px;
    font-size: 10px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
    -o-transform: rotate(90deg); /* Opera */
  }
</style>
<template>
  <div>
    <van-row>
      <van-calendar v-model="show" :default-date="vantDate.defaultDate" :min-date="vantDate.minDate" color="#409EFF"
                    @confirm="onConfirm"/>
      <van-col span="24" class="title-blue">
        <div>
          <span>患者随访报表</span>
          <span style="float: right" @click="show=true">{{searchDate}}
            <van-icon name="play" style="float: right" class="arrow"/>
        </span>
        </div>
      </van-col>
    </van-row>

    <!--全院权限人员权限-->

    <van-row class="round-blue" v-show="showWhole">
      <van-col span="12" style="text-align: left">
        全院随访人数
      </van-col>
      <van-col span="6">
        已随访人数
      </van-col>
      <van-col span="6">
        待随访人数
      </van-col>
    </van-row>
    <van-row class="row-white" v-show="showWhole">
      <van-col span="12" style="text-align: left">
        {{wholeCallTotalNum}}
      </van-col>
      <van-col span="6">
        {{wholeCallDoneNum}}
      </van-col>
      <van-col span="5">
        {{wholeCallUnfinishedNum}}
      </van-col>
    </van-row>



    <van-row class="round-blue">
      <van-col span="12" style="text-align: left">
        随访科室
      </van-col>
      <van-col span="6">
        已随访人数
      </van-col>
      <van-col span="6">
        待随访人数
      </van-col>
    </van-row>
    <template v-for="(item,index) in feedbackCallResultList ">
      <van-row class="row-white">

        <van-col span="12" style="text-align: left">
          {{item.departmentName}}
        </van-col>
        <van-col span="6">
          {{item.callDoneNum}}
        </van-col>
        <van-col span="5">
          {{item.callUnfinishedNum}}
        </van-col>
       <!-- <van-col span="1" style="text-align: center">
          <van-icon name="arrow" style="padding-top: 2px"/>
        </van-col>-->
      </van-row>
    </template>



    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>
    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>


  </div>
</template>

<script>
  // 通过export default导入 这里allTest这个变量名是可以随便写的,因为export default有且只有一个
  import api from "@/axios/api";
  import { mapGetters, mapActions } from "vuex";
  // name随便写 反正default只有一个
  export default {
    name: 'department-feedback-info',
    computed: {
       ...mapGetters(["token"])
    },
    watch: {
      token: {
       immediate: true,
       handler: function(val) {
        if (val) {
           this.getFeedbackCallInfo();
         }
       }
      }
    },
    data() {
      return {
        info: '',
        //字符串类型日期
        searchDate: this.$route.query.searchDate,
        depId:this.$route.query.depId,
        //Calendar日历控件
        vantDate: {
          //默认时间 van日历控件只支持date类型参数
          defaultDate: new Date(Date.parse(this.$route.query.searchDate.replace(/-/g, "/"))),
          //可选择最小时间
          minDate: new Date(Date.parse('1970-01-01'.replace(/-/g, "/")))
        },
        //日期控件默认隐藏
        show: false,
        showWhole:false,
        feedbackCallResultList: [],
        wholeCallTotalNum:'',
        wholeCallDoneNum:'',
        wholeCallUnfinishedNum:'',
      }
    },
    created: function () {
      if(!this.depId){
        this.showWhole = true;
      }
      this.getFeedbackCallInfo();
    },
    methods: {
      formatDate(date) {
        return date.toLocaleDateString().replace(/\//g, '-');
      },
      //弹出日期控件
      onConfirm(date) {
        this.show = false;
        this.searchDate = this.formatDateString(date);
        this.getFeedbackCallInfo();
      },

      //获取电话随访科室结果
      getFeedbackCallInfo() {
        if(!this.depId){
          api.getFeedbackCallInfo(this.searchDate).then(res => {
            this.feedbackCallResultList = res.callResultLists;
            this.wholeCallTotalNum = res.wholeCallTotalNum;
            this.wholeCallDoneNum = res.wholeCallDoneNum;
            this.wholeCallUnfinishedNum = res.wholeCallUnfinishedNum;
          });
        }else{
          api.getDeptFeedbackCallInfo(this.searchDate,this.depId).then(res => {
            this.feedbackCallResultList = res.callResultLists;
          });

        }
      },

      formatDateString(date){
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
      },






    },



  }
</script>



// WEBPACK FOOTER //
// src/hospital-admin/pages/department-feedback-info.vue